import { render, staticRenderFns } from "./ModalFormObjective.vue?vue&type=template&id=5182ab4c&"
import script from "./ModalFormObjective.vue?vue&type=script&lang=js&"
export * from "./ModalFormObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports